export const CatalogEndpoints = {
  uploadFile: 'Generic/UploadFile',
  deleteFile: 'Generic/DeleteFile',
  GetSite: 'Sites/GetSite',
  GetSiteService: 'Sites/GetSiteService',
  GetSiteNonAlcBalance: 'Sites/GetSiteNonAlcBalance',
  GetAllPrograms: 'Program/GetAll',
  AddProgram: 'Program/Add',
  UpdateProgram: 'Program/Update',
  DeleteProgram: 'Program/Delete',
  makeProgramDefault: 'Program/UpdateDefault',
  UpdatePorgramVisible: 'Program/UpdateVisible',
  GetProgramBySite: 'Program/GetProgrameBySite',
  GetAllAddedVendors: 'Vendor/GetRecords',
  AddNewVendor: 'Vendor/AddVendor',
  DeleteVendor: 'Vendor/DeleteVendor',
  GetDBVendors: 'Vendor/SearchInDatabase',
  AddVendorFromDB: 'Vendor/AddVendorFromDatabase',
  GetVendorDropdownList: 'Vendor/GetSiteVendorDropdownList',
  GetVendorDetails: 'Vendor/GetSiteVendor',
  EditVendor: 'Vendor/EditSiteVendor',
  ExportVendors: 'Vendor/ExportVendors',
  GetAllAddedInvestors: 'Investors/GetRecords',
  AddNewInvestor: 'Investors/AddInvestor',
  DeleteInvestor: 'Investors/DeleteInvestor',
  GetDBInvestors: 'Investors/SearchInDatabase',
  AddInvestorFromDB: 'Investors/AddInvestorFromDatabase',
  ExportInvestors: 'Investors/ExportInvestors',
  GetAllTags: 'Tag/GetAll',
  AddTagGroup: 'Tag/Add',
  UpdateTagGroup: 'Tag/Update',
  DeleteTagGroup: 'Tag/Delete',
  GetTagGroupName: 'Tag/GetTagGroupName',
  AddTag: 'Tag/AddTag',
  UpdateTag: 'Tag/UpdateTag',
  DeleteTag: 'Tag/DeleteTag',
  GetTagsDropdownlist: 'Tag/GetTagsDropdownlist',
  GetInvestorsBySite: 'Investors/GetInvestorBySite',
  GetInvestorDetails: 'Investors/GetInvestorDetails',
  GetInvestorTerms: 'Investors/GetInvestorTerms',
  GetInvestmentDescription: 'Investments/GetInvestmentDescription',
  GetAllInvestments: 'Investments/GetInvestments',
  GetInvestmentById: 'Investments/GetInvestment',
  GetInvoicePdf: 'Investments/GetInvoicePdf',
  GetRefund: 'Refunds/GetRefundsById',
  GetCredit: 'Credits/GetCreditsById',
  GetDeposit: 'Deposits/GetDepositsById',
  GetInternalTransfer: 'Transfers/GetInternalTransfer',
  GetResourceRecords: 'PayBevResource/GetResourceRecords',
  GetAnnouncement: 'Sites/GetAnnouncement',
  UpdateSeenAnnouncement: 'Sites/UpdateSeenAnnouncement',
  GetMaintenance: 'Sites/GetAllMaintainance',
  GetCompanyName: 'SupplierPortal/GetCompanyName',
  Register: 'Authenticate/Register',
} as const;
